import { Slugs } from 'common/urls/Slugs';
import React from 'react';
import { RouteChildrenProps } from 'react-router';
import { Redirect } from 'react-router-dom';
import { LoginOrSignUpModalContent } from 'src/auth/modal/LoginOrSignUpModalContent';
import { ShefLogo } from 'src/pages/consumer/components/header-v2/shared-components/ShefLogo';
import { ifProp } from 'src/shared/styled-utils/ifProp';
import { getSlug } from 'src/shared/utils/RouteUtilities';
import styled, { css } from 'styled-components';
import { useScreenContext } from 'web-common/src/shared/context/ScreenContext/hook';
import { Colors, ScreenWidth, ScreenWidthValues, Spacing } from 'web-common/src/shared/styles';
import { useCurrentUser } from '../../shared/hooks/useCurrentUserHook';

const Background = styled.div<{ fullScreenView?: boolean }>`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: center;

  ${ifProp(
    'fullScreenView',
    css`
      background: ${Colors.WHITE};
    `,
    css`
      background: ${Colors.GRAY_LITE_30};
    `
  )}
`;

const ModalContainer = styled.div<{ fullScreenView?: boolean }>`
  ${ifProp(
    'fullScreenView',
    css`
      width: 100%;
    `,
    css`
      background: ${Colors.WHITE};
      border-radius: ${Spacing.SINGLE};
      filter: drop-shadow(0px 0px 15px rgba(0, 0, 0, 0.1));

      width: 480px;
      max-width: calc(100% - calc(${Spacing.DOUBLE}));
      margin: 112px auto;
      overflow: hidden;
    `
  )}
`;

export const LoginPage: React.FC<RouteChildrenProps> = ({ match }) => {
  const { nearestScreenWidthValue } = useScreenContext();
  const [currentUser] = useCurrentUser();

  const isFullScreen = nearestScreenWidthValue <= ScreenWidthValues[ScreenWidth.EXTRA_SMALL];

  const redirectParam = getSlug(match, Slugs.REDIRECT);
  const redirectPath = redirectParam ? decodeURIComponent(redirectParam) : '/';

  if (currentUser) {
    return <Redirect to={redirectPath} />;
  }

  return (
    <Background fullScreenView={isFullScreen}>
      {isFullScreen ? null : (
        <div className='flex h-16 w-full shrink-0 items-center justify-center bg-white'>
          <ShefLogo height={Spacing.DOUBLE} color={Colors.RADISH} />
        </div>
      )}
      <ModalContainer fullScreenView={isFullScreen}>
        <LoginOrSignUpModalContent fullScreenView={isFullScreen} />
      </ModalContainer>
    </Background>
  );
};

export default LoginPage;
